/**
 * sharedSelection
 *
 * The active {verticalStackId, subStackId, jobTitleId} shared between the
 * Comp page and the JD Descriptions Comparison tab - old Angular's
 * Config.stackModel, ported.
 *
 * DELIBERATELY IN MEMORY ONLY (2026-08-20). The first port of this used
 * localStorage, matching old's Config.stackModel setter literally. That was
 * wrong for this app: localStorage outlives the browser tab, so a fresh
 * page load restored whatever role was last clicked - the comp page opened
 * on "Sales / Chief Revenue Officer" instead of its All default, which is
 * not what anyone asked for and looks broken.
 *
 * A module-level variable gives exactly the intended lifetime:
 *   - fresh page load  -> null  -> Comp opens on All, JD tab opens empty
 *   - Comp -> JD·Skills -> the picked role carries across
 *   - JD·Skills -> Comp -> Comp restores that same role (Shell unmounts the
 *     page on every view switch, so component state alone can't do this)
 *   - Comp explicitly set to All -> cleared -> JD tab goes back to empty
 */

let selection = null;

export function getSharedSelection() {
  return selection;
}

export function setSharedSelection(next) {
  selection = next;
}

export function clearSharedSelection() {
  selection = null;
}
